// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control-label[data-v-a46b0efa] {\n  display: flex;\n  justify-content: space-between;\n  padding: 0px;\n}\n.form-control-label h4[data-v-a46b0efa],\n.form-control-label p[data-v-a46b0efa] {\n  margin-bottom: 0.5em;\n}", ""]);
// Exports
module.exports = exports;
